export default {
  computed: {
    internalScaffolding () {
      return this.expressionResolver(this._.cloneDeep(this.config))
    }
  },
  mounted() {
    this.initSubriberAddress()
  },
  methods: {
    listenConsumer() {},
    initSubriberAddress() {
      let vm = this
      if(this.config.subribers) {
        this.config.subribers = this.config.subribers.map((row) => row.map((cell) => eval(cell)))
      }
    },
    triggerOnInput(payload) {
      if(this.config.onInput) {
        this.config.onInput(payload)
      }
    }
  }
}
